"use strict";

var _regeneratorRuntime = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _classCallCheck = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass");

var _get = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pow = void 0;

var grpc_authentication_1 = require("@textile/grpc-authentication");

var loglevel_1 = __importDefault(require("loglevel"));

var api_1 = require("./api");

var logger = loglevel_1.default.getLogger('pow');
/**
 * Pow a client wrapper for interacting with the Textile Powergate API.
 * @example
 * Initialize the Bucket API and open an existing bucket (or create if new).
 * ```typescript
 * import { Pow, PrivateKey, UserAuth } from '@textile/hub'
 *
 * const checkHealth = async (auth: UserAuth, user: PrivateKey) => {
 *   const pow = Pow.withUserAuth(auth)
 *   // Scope the API to the current user
 *   await pow.getToken(user)
 *   // List adrs
 *   const health = pow.health()
 * }
 * ```
 */

var Pow = /*#__PURE__*/function (_grpc_authentication_) {
  _inherits(Pow, _grpc_authentication_);

  var _super2 = _createSuper(Pow);

  function Pow() {
    _classCallCheck(this, Pow);

    return _super2.apply(this, arguments);
  }

  _createClass(Pow, [{
    key: "getToken",

    /**
     * {@inheritDoc @textile/hub#GrpcAuthentication.getToken}
     *
     * @example
     * ```@typescript
     * import { Pow, PrivateKey } from '@textile/hub'
     *
     * async function example (pow: Pow, identity: PrivateKey) {
     *   const token = await pow.getToken(identity)
     *   return token // already added to `pow` scope
     * }
     * ```
     */
    value: function getToken(identity) {
      var _this = this;

      var _super = Object.create(null, {
        getToken: {
          get: function get() {
            return _get(_getPrototypeOf(Pow.prototype), "getToken", _this);
          }
        }
      });

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", _super.getToken.call(this, identity));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * {@inheritDoc @textile/hub#GrpcAuthentication.getTokenChallenge}
     *
     * @example
     * ```typescript
     * import { Pow, PrivateKey } from '@textile/hub'
     *
     * async function example (pow: Pow, identity: PrivateKey) {
     *   const token = await pow.getTokenChallenge(
     *     identity.public.toString(),
     *     (challenge: Uint8Array) => {
     *       return new Promise((resolve, reject) => {
     *         // This is where you should program PrivateKey to respond to challenge
     *         // Read more here: https://docs.textile.io/tutorials/hub/production-auth/
     *       })
     *     }
     *   )
     *   return token
     * }
     * ```
     */

  }, {
    key: "getTokenChallenge",
    value: function getTokenChallenge(publicKey, callback) {
      var _this2 = this;

      var _super = Object.create(null, {
        getTokenChallenge: {
          get: function get() {
            return _get(_getPrototypeOf(Pow.prototype), "getTokenChallenge", _this2);
          }
        }
      });

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", _super.getTokenChallenge.call(this, publicKey, callback));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
    /**
     * @beta
     */

  }, {
    key: "health",
    value: function health() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", api_1.health(this));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
    /**
     * Gets the Powergate node Filecoin peers. This method
     * requires a valid user, token, and session.
     * @beta
     *
     * @example
     * ```typescript
     * import { Pow } from "@textile/hub"
     *
     * async function example(pow: Pow) {
     *    const peersResp = await pow.peers()
     * }
     * ```
     */

  }, {
    key: "peers",
    value: function peers() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", api_1.peers(this));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
    /**
     * Find a peer by peer id.
     * @beta
     * @param peerId The peer id of the peer you want to find.
     */

  }, {
    key: "findPeer",
    value: function findPeer(peerId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", api_1.findPeer(this, peerId));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
    /**
     * Query for network connectedness to the specified peer.
     * @beta
     * @param peerId The peer id to test connectedness for.
     */

  }, {
    key: "connectedness",
    value: function connectedness(peerId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", api_1.connectedness(this, peerId));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
    /**
     * List all Filecoin wallet addresses associated with the current account or user.
     * @beta
     */

  }, {
    key: "addrs",
    value: function addrs() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", api_1.addrs(this));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
    /**
     * Create a new Filecoin wallet address.
     * @beta
     * @param name A human readable name for the wallet address.
     * @param type The type of address to create, wither bls or secp256k1.
     * @param makeDefault Whether or not to make the new address the default address to use in Filecoin transactions.
     */

  }, {
    key: "newAddr",
    value: function newAddr(name, type, makeDefault) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", api_1.newAddr(this, name, type, makeDefault));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
    /**
     * Query for general information about Powergate associated with the current account/user.
     * @beta
     */

  }, {
    key: "info",
    value: function info() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", api_1.info(this));

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
    /**
     * Show information about data stored in Powergate.
     * @beta
     * @param cid The cid of the data to show information about.
     */

  }, {
    key: "show",
    value: function show(cid) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", api_1.show(this, cid));

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
    }
    /**
     * Show information for all data stored in Powergate for the current account/user.
     * @beta
     */

  }, {
    key: "showAll",
    value: function showAll() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                return _context11.abrupt("return", api_1.showAll(this));

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));
    }
    /**
     * Query for Filecoin storage deal records for the current account/user.
     * @beta
     * @param config A config object to control the behavior of the query.
     */

  }, {
    key: "listStorageDealRecords",
    value: function listStorageDealRecords(config) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                return _context12.abrupt("return", api_1.listStorageDealRecords(this, config));

              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));
    }
    /**
     * Query for Filecoin retrieval deal records for the current account/user.
     * @beta
     * @param config A config object to control the behavior of the query.
     */

  }, {
    key: "listRetrievalDealRecords",
    value: function listRetrievalDealRecords(config) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                return _context13.abrupt("return", api_1.listRetrievalDealRecords(this, config));

              case 1:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));
    }
    /**
     * Get the balance for any wallet address.
     * @beta
     * @param address The wallet address to check the balance of.
     */

  }, {
    key: "balance",
    value: function balance(address) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                return _context14.abrupt("return", api_1.balance(this, address));

              case 1:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));
    }
  }], [{
    key: "copyAuth",

    /**
     * {@inheritDoc @textile/hub#GrpcAuthentication.copyAuth}
     *
     * @example
     * Copy an authenticated Users api instance to Pow.
     * ```typescript
     * import { Pow, Users } from '@textile/hub'
     *
     * const usersToPow = async (user: Users) => {
     *   const pow = Pow.copyAuth(user)
     *   return pow
     * }
     * ```
     *
     * @example
     * Copy an authenticated Pow api instance to Users.
     * ```typescript
     * import { Pow, Users } from '@textile/hub'
     *
     * const powToUsers = async (pow: Pow) => {
     *   const user = Users.copyAuth(pow)
     *   return user
     * }
     * ```
     */
    value: function copyAuth(auth, options) {
      return new Pow(auth.context, options === null || options === void 0 ? void 0 : options.debug);
    }
    /**
     * {@inheritDoc @textile/hub#GrpcAuthentication.withUserAuth}
     *
     * @example
     * ```@typescript
     * import { Pow, UserAuth } from '@textile/hub'
     *
     * async function example (userAuth: UserAuth) {
     *   const pow = await Pow.withUserAuth(userAuth)
     * }
     * ```
     */

  }, {
    key: "withUserAuth",
    value: function withUserAuth(auth, options) {
      var res = _get(_getPrototypeOf(Pow), "withUserAuth", this).call(this, auth, options);

      return this.copyAuth(res, options);
    }
    /**
     * {@inheritDoc @textile/hub#GrpcAuthentication.withKeyInfo}
     *
     * @example
     * ```@typescript
     * import { Pow, KeyInfo } from '@textile/hub'
     *
     * async function start () {
     *   const keyInfo: KeyInfo = {
     *     key: '<api key>',
     *     secret: '<api secret>'
     *   }
     *   const pow = await Pow.withKeyInfo(keyInfo)
     * }
     * ```
     */

  }, {
    key: "withKeyInfo",
    value: function withKeyInfo(key, options) {
      var _this3 = this;

      var _super = Object.create(null, {
        withKeyInfo: {
          get: function get() {
            return _get(_getPrototypeOf(Pow), "withKeyInfo", _this3);
          }
        }
      });

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        var auth;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return _super.withKeyInfo.call(this, key, options);

              case 2:
                auth = _context15.sent;
                return _context15.abrupt("return", this.copyAuth(auth, options));

              case 4:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));
    }
  }]);

  return Pow;
}(grpc_authentication_1.GrpcAuthentication);

exports.Pow = Pow;